import { GET, POST, PUT, DELETE } from './api'

export const Create = async (params) => {
    return await POST(`/employees`, params, true);
}

export const Read = async (companyId) => {
    try {
        let allEmployees = [];
        let currentPage = 1;
        let hasNextPage = true;

        while (hasNextPage) {
            console.log(`Buscando página ${currentPage} de funcionários`);
            const response = await GET(
                `/employees?filters[companies][id][$eq]=${companyId}&pagination[page]=${currentPage}&pagination[pageSize]=100`,
                true
            );

            if (response?.data?.length > 0) {
                console.log(`Recebidos ${response.data.length} funcionários`);
                allEmployees = [...allEmployees, ...response.data];
                hasNextPage = response.data.length === 100;
                currentPage++;
            } else {
                hasNextPage = false;
            }
        }

        console.log(`Total de funcionários carregados: ${allEmployees.length}`);
        return { data: allEmployees };
    } catch (error) {
        console.error('Erro ao buscar funcionários:', error);
        throw error;
    }
};

export const ReadEmployeeByUserId = async (userId) => {
    return await GET(`/employees?filters[user][id][$eq]=${userId}&pagination[pageSize]=1000`, true);
}

export const ReadEmployee = async (query) => {
    return await GET(`/employees${query}`, true);
}

export const ReadOne = async (id) => {
    return await GET(`/employees/${id}?populate=*`, true);
}

export const ReadByCompany = async (companyId) => {
    try {
        console.log("Buscando funcionários para a empresa:", companyId);

        const allEmployees = [];
        let page = 1; // Comece pela primeira página
        let totalPages = 1; // Total de páginas, será atualizado na resposta

        do {
            // Fazer a requisição paginada
            const response = await GET(
                `/employees?filters[companies][id][$eq]=${companyId}&populate=*&pagination[page]=${page}&pagination[pageSize]=100`,
                true
            );

            if (response?.data?.length > 0) {
                console.log(`Recebidos ${response.data.length} funcionários na página ${page}`);
                
                // Adicionar registros desta página ao array total
                allEmployees.push(...response.data);

                // Atualizar o número total de páginas baseado na resposta do backend
                const { pageCount } = response.meta.pagination;
                totalPages = pageCount;
            } else {
                console.warn(`Nenhum funcionário encontrado na página ${page}`);
            }

            page++; // Avançar para a próxima página
        } while (page <= totalPages);

        // Mapear os dados para o formato do Select
        const dropdownOptions = allEmployees.map((employee) => ({
            id: employee?.id, // ID do funcionário
            title: employee?.attributes?.nome || "Nome não disponível", // Nome para exibir no select
        }));

        console.log("Opções formatadas para o Select:", dropdownOptions);

        return dropdownOptions; // Retorna a lista formatada
    } catch (error) {
        console.error("Erro ao buscar funcionários:", error);
        throw error; // Propaga o erro para que possa ser tratado
    }
};

export const Update = async (params, id) => {
    return await PUT(`/employees/${id}`, params, true);
}

export const Delete = async (id) => {
    return await DELETE(`/employees/${id}`, true);
}
